import dayjs from 'dayjs';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { Estate } from '@/modules/estate/models/Estate';
import { durationBetween } from '/@/modules/core/app/helpers/DateHelper';
import { EstateStatusKey } from '@/modules/estate/constants/EstateStatusKey';

export class StatusEntry extends BaseEntityModel {
  id?: number;

  modelType?: string;

  modelId?: number;

  estateId?: number;

  status?: EstateStatusKey;

  startedAt?: string;

  endedAt?: string;

  estate?: Relationship<Estate | null>;

  constructor(model: Partial<StatusEntry> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.estateId = model.estateId;
    this.status = model.status;
    this.startedAt = model.startedAt;
    this.endedAt = model.endedAt;

    // @ts-ignore
    this.estate = Estate.mapModelOrNull(model.estate);
  }

  getModelName(): ModelType {
    return ModelType.STATUS_ENTRY;
  }

  get timeInStatus(): number {
    const endedAt: string = this.endedAt ? this.endedAt : dayjs().toISOString();

    return durationBetween(this.startedAt as string, endedAt).asDays();
  }
}
